// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_mw-0";